  // Get the accordion header by its ID
  var acc = document.getElementById('tt-collapse-title-tab');

  acc.addEventListener('click', function () {
    var panel = document.getElementById('tt-collapse-tab-content');
    if (panel.style.display === 'none' || panel.style.display === '') {
      panel.style.display = 'block';
      this.classList.add('active');
    } else {
      panel.style.display = 'none';
      this.classList.remove('active');
    }
  });
